const SuccessfullyIcon = () => (
  <svg
    width="82"
    height="72"
    viewBox="0 0 82 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M68.8691 15.0301C71.2388 15.2605 76.1955 14.4969 77.0645 9.59947C77.9335 4.702 80.2572 3.34598 81.3104 3.28015"
      stroke="#F3603F"
      strokeWidth="0.864209"
      strokeLinecap="round"
    />
    <ellipse
      cx="46.8257"
      cy="35.0081"
      rx="23.6929"
      ry="23.6929"
      fill="#5F63FB"
    />
    <g filter="url(#filter0_d_95_7599)">
      <circle
        cx="46.8257"
        cy="35.0087"
        r="20.4282"
        stroke="white"
        strokeOpacity="0.7"
        strokeWidth="0.576139"
      />
    </g>
    <path
      d="M57.3537 29.8259C57.3537 30.4711 57.1005 31.094 56.6402 31.5389L45.9387 41.9055C45.4554 42.3504 44.8111 42.6174 44.1437 42.6174C43.4762 42.6174 42.8319 42.3504 42.3716 41.9055L37.0093 36.7222C36.5491 36.2773 36.2959 35.6544 36.2959 35.0092C36.2959 34.3641 36.5721 33.7635 37.0323 33.2963C37.5156 32.8514 38.137 32.6067 38.8044 32.5844C39.4718 32.5844 40.0932 32.8291 40.5765 33.2741L44.1437 36.7222L53.0731 28.0907C53.5564 27.6458 54.1777 27.4011 54.8451 27.4011C55.5125 27.4234 56.1339 27.6681 56.6172 28.1352C57.0775 28.5802 57.3537 29.1808 57.3537 29.8259Z"
      fill="white"
    />
    <path
      d="M65.5654 58.698C67.7773 59.3369 72.0535 61.7649 71.4636 66.3654"
      stroke="#F7B23B"
      strokeWidth="0.864209"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.689453 52.2049C4.08365 53.4832 11.401 54.4001 13.5169 47.841M13.5169 47.841C13.8255 46.0337 13.5169 42.4587 9.81419 42.6174C9.10888 44.3586 8.86197 47.841 13.5169 47.841ZM13.5169 47.841C15.0597 48.1275 18.6479 47.8542 20.658 44.4688"
      stroke="#6E89FA"
      strokeWidth="0.864209"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="54.5532" cy="69.7289" r="2.27102" fill="#637BFE" />
    <circle
      cx="76.021"
      cy="33.7675"
      r="2.12698"
      stroke="#C05EFD"
      strokeWidth="0.28807"
    />
    <circle cx="39.9723" cy="2.48695" r="2.48695" fill="#5F63FB" />
    <circle cx="47.0331" cy="6.68533" r="1.31339" fill="#F3603F" />
    <circle
      cx="18.0849"
      cy="25.9747"
      r="2.15765"
      stroke="#F7B23B"
      strokeWidth="0.28807"
    />
    <circle
      cx="23.3727"
      cy="62.2672"
      r="2.38685"
      stroke="#53B175"
      strokeWidth="0.28807"
    />
    <circle
      cx="1.2091"
      cy="1.2091"
      r="1.2091"
      transform="matrix(-1 0 0 1 48.7002 65.9177)"
      fill="#53B175"
    />
    <defs>
      <filter
        id="filter0_d_95_7599"
        x="24.9571"
        y="14.0043"
        width="43.7372"
        height="43.7372"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.864209" />
        <feGaussianBlur stdDeviation="0.576139" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_95_7599"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_95_7599"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default SuccessfullyIcon
